import * as Yup from 'yup';
import React, { useCallback, useState, useRef, useEffect } from 'react';
import Wrapper from '../../../assets/wrappers/UploadAudioVideo'
import { useFormik } from 'formik';
import TopHeader from '../../../components/TopHeader'
import SabhaSaarHeader from '../../../components/SabhaSaarHeader'
import Flatpickr from 'react-flatpickr';
import "flatpickr/dist/themes/material_green.css";
import "flatpickr/dist/flatpickr.css";
import { useDropzone } from 'react-dropzone';
import HumbleIcon from '../../../assets/images/humbleicon.png'
import Footer from '../../../components/Footer';
import { useDispatch } from 'react-redux';
import { languages, setFileData, setApiInfo, fetchMeetingTypes, setMeetingAttendees, closeDedupErrorModal, setDedupErrorModalType } from '../../../features/upload/uploadSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import UserInfo from '../../../components/UserInfo';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import protectedAPI from '../../../services/axiosInstance';
const { FaExclamationTriangle, FaCalendarAlt, FaPlayCircle, FaTimes, FaUpload, FaEdit } = require("react-icons/fa");
const { IoArrowBack, IoAdd } = require("react-icons/io5");

const attendeesSchema = Yup.object().shape({
    male: Yup.number().integer("Must be integer").min(0).required(),
    female: Yup.number().integer("Must be integer").min(0).required(),
    others: Yup.number().integer("Must be integer").min(0).required(),
    general: Yup.number().integer("Must be integer").min(0).required(),
    obc: Yup.number().integer("Must be integer").min(0).required(),
    sc: Yup.number().integer("Must be integer").min(0).required(),
    st: Yup.number().integer("Must be integer").min(0).required(),
    casteOthers: Yup.number().integer("Must be integer").min(0).required(),
});

const UploadAudioVideo: React.FC = () => {
    const { portal, meetingDetailsNirnany } = useSelector((state: RootState) => state.auth);
    const { showDedupErrorModal, dedupErrorMessage, dedupErrorModalType } = useSelector((state: any) => state.upload);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [files, setFiles] = useState<any[]>([]);
    const [fileError, setFileError] = useState<string | null>(null);
    const [processing, setProcessing] = useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadbtnDis, setUploadBtnDis] = useState<any>(false);
    const [uploadComplete, setUploadComplete] = useState(false);
    const uploadIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const uploadControllerRef = useRef<AbortController | null>(null);
    const { meetingTypes, loading, MeetingTypeFetched, currentDateIST } = useSelector((state: RootState) => state.upload);
    const [showModal, setShowModal] = useState(false);
    const [showModaldata, setShowModalData] = useState(false);
    const [error, setError] = useState<string>("");
    const [isAllowed, setIsAllowed] = useState(true);
    const [remaining, setRemaining] = useState<number | string>(0);
    const [limit, setLimit] = useState<number | string>(0);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const [storageData, setStorageData] = useState<any>(() => {
        const saved = localStorage.getItem('loginDetails');
        try {
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            console.error('Failed to parse loginDetails from localStorage:', e);
            return {};
        }
    });
    const isStateLevelAllowed =
        storageData?.state_code === 22 &&
        storageData?.zpcode === 0 &&
        storageData?.bpcode === 0 &&
        storageData?.gpcode === 0;

    const WORLD_ENVIRONMENT_DAY = {
        id: 38,
        name: "World Environment Day 2026",
    };


    // const filteredMeetingTypes = [
    //     ...(meetingTypes
    //         ?.filter((item) => {
    //             if (item.id === 32) {
    //                 return isStateLevelAllowed;
    //             }
    //             return true;
    //         })
    //         .map((item) => ({
    //             ...item,
    //             sub_options: item.sub_options.filter((sub) => sub.id !== 38),
    //         }))
    //         .filter((item) => item.sub_options.length > 0) || []),
    // ];


    const filteredMeetingTypes = [
        ...(meetingTypes
            ?.filter((item) => {
                if (item.id === 32) {
                    return isStateLevelAllowed;
                }
                return true;
            })
            .map((item) => {
                let subOptions = item.sub_options.filter((sub) => sub.id !== 38);
                if (item.id === 3) {
                    const targetIndex = subOptions.findIndex((sub) => sub.id === 19);
                    if (targetIndex > -1) {
                        const [targetOption] = subOptions.splice(targetIndex, 1);
                        subOptions.unshift(targetOption);
                    }
                }
                return {
                    ...item,
                    sub_options: subOptions,
                };
            })
            .filter((item) => item.sub_options.length > 0) || []),
    ];

    const reorderedMeetingTypes = (() => {
        const list = [...filteredMeetingTypes];
        const parentIndex = list.findIndex((item) => item.id === 3);

        if (parentIndex > -1) {
            const [targetParent] = list.splice(parentIndex, 1);
            list.splice(1, 0, targetParent);
        }

        return list;
    })();


    useEffect(() => {
        checkRemainingMinutes();
    }, [])

    const checkRemainingMinutes = async () => {
        try {
            const authData = JSON.parse(localStorage.getItem("loginDetails") || "{}");
            const response = await protectedAPI.post(
                `${baseUrl}api/limit-mom-generate`,
                {
                    statecode: String(authData?.state_code || "0"),
                    zpcode: String(authData?.zpcode || "0"),
                    bpcode: String(authData?.bpcode || "0"),
                    gpcode: String(authData?.gpcode || "0"),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = response?.data?.data;
            setIsAllowed(data?.allowed);
            setLimit(data?.limit);
            setRemaining(data?.remaining);
        } catch (error) {
            setIsAllowed(false);
            setLimit(0);
            setRemaining(0);
        }
    };

    const [savedFormData, setSavedFormData] = useState({
        male: 0,
        female: 0,
        others: 0,
        general: 0,
        obc: 0,
        sc: 0,
        st: 0,
        casteOthers: 0,
    });

    const [tempFormData, setTempFormData] = useState(savedFormData);
    const [s3Key, setS3Key] = useState<any>("")
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!MeetingTypeFetched && !loading) {
            dispatch(fetchMeetingTypes() as any);
        }
    }, [MeetingTypeFetched, loading, dispatch]);

    const isInRange = (start: string, end: string) => {
        if (!currentDateIST) return false;
        const current = new Date(currentDateIST);
        const year = current.getFullYear();
        const startDate = new Date(`${year}-${start}`);
        const endDate = new Date(`${year}-${end}`);
        if (endDate < startDate) {
            return current >= startDate || current <= endDate;
        }
        return current >= startDate && current <= endDate;
    };

    const mandatoryDateRanges: Record<number, { start: string; end: string }> = {
        7: { start: "01-26", end: "02-10" },
        8: { start: "04-24", end: "05-03" },
        9: { start: "08-13", end: "08-24" },
        10: { start: "09-30", end: "10-31" }
    };

    const formik = useFormik({
        initialValues: {
            meetingDate: meetingDetailsNirnany?.meeting_date
                ? new Date(meetingDetailsNirnany?.meeting_date)
                : new Date(),
            meetingType: portal === "N" ? 30 : '',
            sourceLanguage: '',
            meetingTitle: String(meetingDetailsNirnany?.meeting_title || "")
        },
        validationSchema: Yup.object({
            meetingDate: Yup.date().required('Meeting date is required'),
            meetingType: Yup.string().required('Meeting Type is required'),
            meetingTitle: Yup.string().required('Meeting Title is required'),
            sourceLanguage: Yup.string()
                .required('Meeting language is required')
                .notOneOf([''], 'Please select a valid language'),
        }),
        onSubmit: async (values) => {
            if (isSubmitting) return;
            if (fileError || files.length === 0) {
                setFileError('Please upload a valid file.');
                return;
            }
            if (!showModaldata) {
                toast.error("Please fill in Attendees Details before submitting.");
                return;
            }
            setIsSubmitting(true);

            const genderTotal = savedFormData.male + savedFormData.female + savedFormData.others;
            const meetingAttendees = {
                "by_gender": {
                    "Male": savedFormData.male,
                    "Female": savedFormData.female,
                    "Others": savedFormData.others
                },
                "by_social_category": {
                    "SC": savedFormData.sc,
                    "ST": savedFormData.st,
                    "OBC": savedFormData.obc,
                    "General": savedFormData.general,
                    "Others": savedFormData.others
                },
                "total_attendees": genderTotal
            }
            const file = files[0];
            const authData = JSON.parse(localStorage.getItem('loginDetails') || '{}');
            try {
                const duration = await getAudioDuration(file);
                const payload = {
                    s3_key: s3Key,
                    meeting_date: values.meetingDate.toLocaleDateString('en-CA'),
                    source_language: values.sourceLanguage,
                    state_code: authData.state_code,
                    state_name_english: authData.state_name_english,
                    zpcode: authData.zpcode,
                    zpname: authData.zpname,
                    bpcode: authData.bpcode,
                    bpname: authData.bpname,
                    meeting_type_id: values.meetingType,
                    gpcode: authData.gpcode,
                    gpname: authData.gpname,
                    entity_level: authData.entity_level,
                    duration: Math.round(duration),
                    meeting_title: values.meetingTitle,
                    meeting_attendees: meetingAttendees,
                    auth_source: portal
                };
                const response = await protectedAPI.post(`${baseUrl}api/start-processing`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data?.msg_code === 200) {
                    dispatch(setApiInfo({
                        task_id: response.data?.task_id,
                        s3Key: payload.s3_key,
                    }));
                    dispatch(setMeetingAttendees(meetingAttendees));
                    let meetingTypeName = "";
                    let meetingParentName = "";

                    meetingTypes.forEach((parent) => {
                        parent.sub_options.forEach((sub) => {
                            if (sub.id === Number(values.meetingType)) {
                                meetingTypeName = sub.name;
                                meetingParentName = parent.name;
                            }
                        });
                    });

                    dispatch(setFileData({
                        fileName: file.name,
                        fileType: file.type,
                        fileSize: file.size,
                        file,
                        language: values.sourceLanguage,
                        date: values.meetingDate.toISOString(),
                        meetingType: values.meetingType,
                        meetingTitle: values.meetingTitle,
                        meetingTypeName: meetingTypeName
                    }));
                    navigate('/processing');
                }
                if (response.data?.msg_code === 400) {
                    toast.error("Unable to process. Please try again later.");
                    return;
                }
                if (response.data?.msg_code === 500) {
                    toast.error('Internal Server Error');
                    return;
                }
            } catch (error) {
                console.error('Error getting duration or starting processing:', error);
                toast.error('Something went wrong');
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    const onDrop = useCallback((acceptedFiles: File[]) => {
        debugger;

        const allowedTypes = [
            "audio/wav",
            "audio/mp3",
            "audio/mpeg",
            "audio/x-m4a",
            "audio/mp4",
            "video/mp4",
        ];

        const maxSize = 1024 * 1024 * 1024;
        const file = acceptedFiles[0];

        if (!file) return;

        const extension = file.name
            .split(".")
            .pop()
            ?.toLowerCase();
        if (
            extension === "m4v" ||
            !allowedTypes.includes(file.type) ||
            file.size > maxSize
        ) {
            setFileError(
                "Only MP4, WAV, MP3, M4A formats under 1GB are allowed."
            );
            return;
        }

        const url = URL.createObjectURL(file);

        const media = document.createElement(
            file.type.includes("video") ? "video" : "audio"
        );

        media.src = url;

        media.onloadedmetadata = () => {
            const durationInSeconds = media.duration;
            if (durationInSeconds < 300) {
                toast.error("Meeting Duration must be at least 5 Minute long.");
                URL.revokeObjectURL(url);
                return;
            }
            setFileError(null);
            setFiles([file]);
            setProcessing(true);
            setPreviewUrl(null);
            setTimeout(() => {
                setPreviewUrl(url);
                setProcessing(false);
            }, 2000);
        };

        media.onerror = () => {
            URL.revokeObjectURL(url);
            setFileError("Failed to read media file. Please upload a valid file.");
        };
    }, []);
    const getAudioDuration = (file: File): Promise<number> => {
        return new Promise((resolve, reject) => {
            const audio = document.createElement('audio');
            audio.preload = 'metadata';
            audio.onloadedmetadata = () => {
                window.URL.revokeObjectURL(audio.src);
                resolve(audio.duration);
            };
            audio.onerror = () => {
                reject('Invalid audio file');
            };
            audio.src = URL.createObjectURL(file);
        });
    };

    const uploadFile = async () => {
        if (fileError || files.length === 0) {
            setFileError('Please upload a valid file.');
            return;
        }
        if (files.length === 0 || uploadProgress > 0) return;
        formik.setTouched({
            meetingDate: true,
            sourceLanguage: true,
        });
        const errors = await formik.validateForm();
        if (errors.meetingDate || errors.sourceLanguage) {
            return;
        }
        setUploadBtnDis(true);
        const file = files[0];
        const authData = JSON.parse(localStorage.getItem('loginDetails') || '{}');
        setUploadComplete(false);
        setProcessing(true);
        setUploadProgress(0);

        try {
            const response = await protectedAPI.post(`${baseUrl}api/generate-presigned-url`,
                {
                    file_name: file.name,
                    state_code: authData.state_code,
                    state_name_english: authData.state_name_english,
                    zpcode: authData.zpcode,
                    zpname: authData.zpname,
                    bpcode: authData.bpcode,
                    bpname: authData.bpname,
                    gpcode: authData.gpcode,
                    gpname: authData.gpname,
                    entity_level: authData.entity_level,
                },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const { msg_code, msg, presigned_url, s3_key } = response.data;
            setS3Key(s3_key);
            if (msg_code !== 200 || !presigned_url) {
                toast.error(msg || 'Something went wrong');
                setUploadProgress(0);
                setProcessing(false);
                return;
            }
            setUploadProgress(1);
            uploadControllerRef.current = new AbortController();
            await axios.put(presigned_url, file, {
                headers: { 'Content-Type': file.type },
                signal: uploadControllerRef.current.signal,
                onUploadProgress: (progressEvent) => {
                    const total = progressEvent.total ?? 1;
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / total);
                    setUploadProgress(Math.max(percentCompleted, 1));
                },
            });

            setUploadProgress(100);
            setUploadComplete(true);
            setProcessing(false);
            toast.success('Upload completed!');
        } catch (error: any) {
            if (axios.isCancel(error)) {
                toast.error("Upload cancelled !!");
            } else {
                console.error('Upload failed:', error);
                toast.error(error?.response?.data?.msg || 'Upload failed. Please try again later.');
            }
            setUploadProgress(0);
            setProcessing(false);
        } finally {
            setUploadBtnDis(false);
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'audio/wav': ['.wav'],
            'audio/mp3': ['.mp3'],
            'audio/mpeg': ['.mpeg', '.mp3'],
            'audio/x-m4a': ['.m4a'],
            'audio/mp4': ['.m4a'],
            'video/mp4': ['.mp4'],
        }
    });

    const reset = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        e.preventDefault();
        if (uploadControllerRef.current) {
            uploadControllerRef.current.abort();
            uploadControllerRef.current = null;
        }
        if (uploadIntervalRef.current) {
            clearInterval(uploadIntervalRef.current);
            uploadIntervalRef.current = null;
        }
        setFiles([]);
        setPreviewUrl(null);
        setFileError(null);
        setUploadProgress(0);
        setUploadComplete(false);
        setProcessing(false);
        formik.setFieldValue('sourceLanguage', '');
        formik.setFieldValue('meetingType', portal === "N" ? 30 : '');
    };

    const handleOpenModal = () => {
        setTempFormData(savedFormData);
        setError("");
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setTempFormData(savedFormData);
        setError("");
        setShowModal(false);
    };

    const handleEdit = () => {
        handleOpenModal();
    };

    const savedGenderTotal = savedFormData.male + savedFormData.female + savedFormData.others;
    const savedCasteTotal = savedFormData.general + savedFormData.obc + savedFormData.sc + savedFormData.st + savedFormData.casteOthers;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const sanitized = value.replace(/^0+(?=\d)/, "") || "0"
        setTempFormData((prev) => ({
            ...prev,
            [name]: parseInt(sanitized, 10),
        }));
    };

    const genderTotal = tempFormData.male + tempFormData.female + tempFormData.others;
    const casteTotal = tempFormData.general + tempFormData.obc + tempFormData.sc + tempFormData.st + tempFormData.casteOthers;

    const handleSave = async () => {
        try {
            await attendeesSchema.validate(tempFormData, { abortEarly: false });
            const genderTotal = tempFormData.male + tempFormData.female + tempFormData.others;
            const casteTotal = tempFormData.general + tempFormData.obc + tempFormData.sc + tempFormData.st + tempFormData.casteOthers;

            if (genderTotal < 10 || genderTotal > 9999) {
                setError("Total attendees must be between 10 and 9999.");
                return;
            }

            if (genderTotal !== casteTotal) {
                setError("Gender total must equal Caste total.");
                return;
            }
            setSavedFormData(tempFormData);
            setError("");
            setShowModal(false);
            setShowModalData(true);

        } catch (err: any) {
            setError(
                err.inner?.map((e: any) => e.message).join(", ") || "Validation failed."
            );
        }
    };
    const getMomLimitMessage = () => {
        if (remaining === "unlimited") return null;
        if (remaining === 2) {
            return "You can generate a maximum of 2 Minutes of Meeting (MoMs) per day using SabhaSaar.";
        }
        if (remaining === 1) {
            return "You have successfully generated 1 Minute of Meeting today. You can generate 1 more Minute of Meeting today.";
        }
        if (remaining === 0) {
            return "You have already generated the maximum allowed 2 Minutes of Meeting for today. Please try again tomorrow to generate new Meeting Minutes.";
        }
        return null;
    };

    return (
        <Wrapper>
            <TopHeader />
            <section className="body-content">
                <SabhaSaarHeader />
                <UserInfo />
                <div className="container mt-3">
                    {getMomLimitMessage() && (
                        <div className={`alert ${remaining === 0 ? "alert-danger" : "alert-warning"}`}>
                            {getMomLimitMessage()}
                        </div>
                    )}
                </div>
                <div className="container" id="uploadMainSkip">
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <h5 className="card-title-cus">Upload Video or Audio File</h5>
                                {
                                    portal !== "N" && <div className="goBack" onClick={() => navigate("/afterLogin")}>
                                        <IoArrowBack size={24} /> Back
                                    </div>
                                }

                            </div>
                            <form onSubmit={formik.handleSubmit}>
                                <fieldset disabled={remaining === 0}>
                                    <div className="form p-3">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor='meetingDate' className="form-label my-2 mandatory">Meeting Date </label>
                                                    <div className="input-group">
                                                        <div className="input-group full-width-group">
                                                            <span className="input-group-text">
                                                                <FaCalendarAlt />
                                                            </span>
                                                            <Flatpickr name="meetingDate"
                                                                id='meetingDate' className="form-control"
                                                                value={formik.values.meetingDate ?? new Date()}
                                                                data-arr={formik.values.meetingDate ?? new Date()}
                                                                options={{
                                                                    dateFormat: 'd/m/Y',
                                                                    maxDate: new Date(),
                                                                    minDate: new Date(new Date().getFullYear(), 3, 1),
                                                                }}
                                                                onChange={(selectedDates: Date[]) => {
                                                                    if (selectedDates.length > 0) {
                                                                        formik.setFieldValue('meetingDate', selectedDates[0]);
                                                                    }
                                                                }}
                                                                disabled={portal === 'N' ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    {formik.touched.meetingDate &&
                                                        typeof formik.errors.meetingDate === 'string' && (
                                                            <span className="error-msg">
                                                                {formik.errors.meetingDate}
                                                            </span>
                                                        )}
                                                </div>
                                            </div>


                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label my-2 mandatory">Meeting Type</label>
                                                    {
                                                        portal !== "N" ? <div className="input-group">
                                                            <select
                                                                name="meetingType"
                                                                className="form-select"
                                                                value={formik.values.meetingType}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                required
                                                            >
                                                                <option value="">Select Meeting Type</option>
                                                                {reorderedMeetingTypes?.map((parent) => {
                                                                    const visibleSubOptions = parent.sub_options.filter((sub) => {
                                                                        if (parent.id === 1 && mandatoryDateRanges[sub.id]) {
                                                                            const { start, end } = mandatoryDateRanges[sub.id];
                                                                            return isInRange(start, end);
                                                                        }
                                                                        return true;
                                                                    });

                                                                    if (visibleSubOptions.length === 0) return null;

                                                                    return (
                                                                        <optgroup key={parent.id} label={parent.name}>
                                                                            {visibleSubOptions.map((sub) => (
                                                                                <option key={sub.id} value={sub.id}>
                                                                                    {sub.name}
                                                                                </option>
                                                                            ))}
                                                                        </optgroup>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div> :
                                                            <input type="text" name="" id="" className='form-control' value={meetingDetailsNirnany?.meeting_type_name} disabled={true} />
                                                    }
                                                    {formik.touched.meetingType && formik.errors.meetingType && (
                                                        <span className="error-msg">{formik.errors.meetingType}</span>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className=" form-label my-2 mandatory">Meeting Language</label>
                                                    <div className="input-group">
                                                        <select
                                                            name="sourceLanguage"
                                                            className="form-select"
                                                            value={formik.values.sourceLanguage}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="">Select Meeting  Language</option>
                                                            {languages.map(lang => (
                                                                <option key={lang.code} value={lang.code}>
                                                                    {lang.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {formik.touched.sourceLanguage && formik.errors.sourceLanguage && (
                                                        <span className="error-msg">{formik.errors.sourceLanguage}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className=" form-label my-2 mandatory">Add Meeting Title</label>
                                                    <div className="input-group">
                                                        <textarea className='form-control ' name="meetingTitle" value={formik.values.meetingTitle}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 1000) {
                                                                    formik.handleChange(e);
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            disabled={portal === 'N' ? true : false}
                                                        />
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        {formik.touched.meetingTitle && formik.errors.meetingTitle && (
                                                            <span className="error-msg">{formik.errors.meetingTitle}</span>
                                                        )}
                                                        <span>
                                                            {formik.values.meetingTitle.length}/1000 Max
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            {!showModaldata ? (
                                                <>
                                                    <label htmlFor="" className="mb-2 mandatory">Add Attendees Details</label>
                                                    <div className="row px-3">
                                                        <div className="attendeesDetails" onClick={handleOpenModal}>
                                                            <span>Add Attendees Details</span>
                                                            <IoAdd className="add-circle" />
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="attendees-summary-box p-3 border-dashed">
                                                    <h5 className="text-center mandatory mb-3">Add Attendees Details</h5>

                                                    <div className="row g-3">
                                                        <div className="col-12 col-md-10 d-flex flex-column flex-md-row">

                                                            <div className="flex-fill p-3 bg-light me-md-2 d-flex flex-column">
                                                                <h6 className="text-center">No. of Attendees Gender wise</h6>
                                                                <div className="gender-data-p mt-2">
                                                                    <p>Male : <b>{savedFormData.male}</b></p>
                                                                    <p>Female : <b>{savedFormData.female}</b></p>
                                                                    <p>Others : <b>{savedFormData.others}</b></p>
                                                                    <p>Total : <b>{savedGenderTotal}</b></p>
                                                                </div>
                                                            </div>

                                                            <div className="flex-fill p-3 bg-success-subtle ms-md-2 d-flex flex-column">
                                                                <h6 className="text-center">No. of Attendees Caste wise</h6>
                                                                <div className="cast-data-p mt-2">
                                                                    <p>General : <b>{savedFormData.general}</b></p>
                                                                    <p>OBC : <b>{savedFormData.obc}</b></p>
                                                                    <p>SC : <b>{savedFormData.sc}</b></p>
                                                                    <p>ST : <b>{savedFormData.st}</b></p>
                                                                    <p>Others : <b>{savedFormData.casteOthers}</b></p>
                                                                    <p>Total : <b>{savedCasteTotal}</b></p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Edit Button */}
                                                        <div className="col-12 col-md-2 d-flex justify-content-center align-items-center mt-2 mt-md-0">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary"
                                                                onClick={handleEdit}
                                                            >
                                                                <FaEdit />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                            )}
                                        </div>
                                        <div className="form-group mt-4">
                                            {!previewUrl && (
                                                <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
                                                    <input {...getInputProps()} />
                                                    <div className="dropzone-content">
                                                        <img src={HumbleIcon} alt="drop-icon" className="drop-icon" />
                                                        {processing ? (
                                                            <p><strong>Processing...</strong></p>
                                                        ) : isDragActive ? (
                                                            <>
                                                                <p>Drop the files here...</p>
                                                                <p>Supported formats: MP4, WAV, MP3, M4A. Maximum file size: 1GB</p>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <p className='mb-0'>Drag & drop file here, or click to browse</p>
                                                                <span className='mb-3'>Or</span>
                                                                <div className="d-flex justify-content-center">
                                                                    <button className='mb-3 btn btn-blue-small'>Click to browse </button>
                                                                </div>

                                                                <p>Supported formats: MP4, WAV, MP3, M4A. Maximum file size: 1GB</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {previewUrl && (
                                                <>
                                                    <div className="preview-area mt-3">
                                                        {files[0]?.type.startsWith('video') ? (
                                                            <video height="auto" controls>
                                                                <source src={previewUrl} type={files[0].type} />
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        ) : (
                                                            <audio controls>
                                                                <source src={previewUrl} type={files[0].type} />
                                                                Your browser does not support the audio tag.
                                                            </audio>
                                                        )}

                                                        <div className="d-flex w-100 align-items-center justify-content-between">
                                                            <p className="mt-2"><strong>{files[0].name}</strong></p>
                                                            <button type="submit" onClick={reset} className="btn btn-danger  mt-3 ">
                                                                <FaTimes />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {uploadProgress > 0 && uploadProgress < 100 && (
                                            <div className="progress my-3">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{ width: `${uploadProgress}%` }}
                                                    aria-valuenow={uploadProgress}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    {uploadProgress}%
                                                </div>
                                            </div>
                                        )}


                                        {fileError && <span className="error-msg">{fileError}</span>}
                                        {isAllowed && (
                                            <div className="btn-conainer">
                                                {previewUrl && !uploadComplete && (
                                                    <button
                                                        type="button"
                                                        className={`btn mt-3 ${formik.isValid && formik.dirty && files.length > 0 && showModaldata && !fileError
                                                            ? 'btn-upload'
                                                            : 'btn-grey not-allowed'
                                                            }`}
                                                        onClick={uploadFile}
                                                        disabled={!(formik.isValid && formik.dirty && files.length > 0 && showModaldata && !fileError)}
                                                    >
                                                        <FaUpload />
                                                        {uploadbtnDis ? 'Uploading...' : 'Upload'}
                                                    </button>
                                                )}

                                                <button type="submit" disabled={isSubmitting || !(formik.isValid && formik.dirty && files.length > 0 && showModaldata && !fileError && uploadComplete)}
                                                    className={`btn mt-3 ${!isSubmitting && formik.isValid && formik.dirty && files.length > 0 && showModaldata && !fileError && uploadComplete ? "btn-blue" : "btn-grey not-allowed"}`}>
                                                    {isSubmitting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Processing...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FaPlayCircle /> Start Processing
                                                        </>
                                                    )}
                                                </button>

                                            </div>
                                        )}
                                        <div className="text-end">

                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (

                <>
                    {/* blurred backdrop */}
                    <div className={`backdrop ${showModal ? "show" : ""}`} onClick={handleCloseModal}></div>
                    <div className={`modal fade ${showModal ? "show" : ""}`} style={{ display: "block" }} tabIndex={-1}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="attendees-header-modal">
                                    <h5 className="modal-title mandatory">Add Attendees Details</h5>
                                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                                </div>
                                <div className="modal-body">
                                    {/* Gender Wise */}
                                    <div className="gender-Cast-wise-box">
                                        <p>No. of Attendees Gender wise</p>
                                        <div className="row">
                                            {["male", "female", "others"].map((field) => (
                                                <div className="col-md-3" key={field}>
                                                    <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                                                    <input
                                                        type="text"
                                                        name={field}
                                                        min="0"
                                                        className="form-control"
                                                        value={tempFormData[field as keyof typeof tempFormData] ?? 0}
                                                        onChange={handleChange}
                                                        maxLength={4}
                                                    />
                                                </div>
                                            ))}

                                            <div className="col-md-3">
                                                <label>Total</label>
                                                <input type="number" readOnly className="form-control" value={genderTotal} />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Caste Wise */}
                                    <div className="gender-Cast-wise-box mt-2">
                                        <p>No. of Attendees Caste wise</p>
                                        <div className="row">
                                            {[
                                                { id: "general", label: "General" },
                                                { id: "obc", label: "OBC" },
                                                { id: "sc", label: "SC" },
                                                { id: "st", label: "ST" },
                                                { id: "casteOthers", label: "Others" },
                                            ].map((field) => (
                                                <div className="col-md-2 mb-3" key={field.id}>
                                                    <label>{field.label}</label>
                                                    <input
                                                        type="text"
                                                        name={field.id}
                                                        min="0"
                                                        className="form-control"
                                                        maxLength={4}
                                                        value={tempFormData[field.id as keyof typeof tempFormData] ?? 0}

                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            ))}
                                            <div className="col-md-2 mb-3">
                                                <label>Total</label>
                                                <input type="number" readOnly className="form-control" value={casteTotal} />
                                            </div>
                                        </div>
                                    </div>
                                    {error && <div className="text-danger mt-2">{error}</div>}

                                    <div className="my-2">
                                        <button type="button" className="btn btn-success w-100" onClick={handleSave}>
                                            Save Changes
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <Footer />

            {showDedupErrorModal && (
                <>
                    <div
                        className={`backdrop ${showDedupErrorModal ? "show" : ""}`}
                        onClick={() => dispatch(closeDedupErrorModal())}
                    ></div>

                    <div className={`modal fade ${showDedupErrorModal ? "show d-block" : ""}`} tabIndex={-1}>
                        <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content shadow-lg border-0">
                                <div className="attendees-header-modal">
                                    <h5 className="modal-title">
                                        {dedupErrorModalType === "PROCESSING_FAILED" ? "Processing Failed" : "Duplicate Detected"}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => dispatch(closeDedupErrorModal())}
                                    ></button>
                                </div>

                                <div className="modal-body text-center py-4">
                                    <div className={`mb-3 ${dedupErrorModalType === "PROCESSING_FAILED" ? "text-danger" : "text-warning"}`}>
                                        <FaExclamationTriangle size={48} />
                                    </div>
                                    <h5 className="text-dark">
                                        {dedupErrorModalType === "PROCESSING_FAILED" ? "Invalid Media File" : "File Already Uploaded"}
                                    </h5>
                                    <div className="alert alert-danger mt-3 mb-0" style={{ fontSize: '0.9rem' }}>
                                        {dedupErrorMessage}
                                    </div>
                                </div>

                                <div className="modal-footer border-0 justify-content-center pb-4">
                                    <button
                                        type="button"
                                        className="btn btn-secondary w-100"
                                        onClick={() => {
                                            dispatch(closeDedupErrorModal());
                                            navigate("/upload");
                                        }}
                                    >
                                        Back to Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </Wrapper>
    )
}
export default UploadAudioVideo